import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
`;
